import FeedbackIcon from './FeedbackIcon.gl2025';

const InfoFeedbackIcon = function ({ variant='primary', size='md' }) {
    return FeedbackIcon({variant, size, color: 'primary', name: 'zap'});
};

const ErrorFeedbackIcon = function ({ variant='primary', size='md' }) {
    return FeedbackIcon({variant, size, color: 'error', name: 'alert-circle'});
};

const WarningFeedbackIcon = function ({ variant='primary', size='md' }) {
    return FeedbackIcon({variant, size, color: 'warning', name: 'alert-triangle'});
};

const SuccessFeedbackIcon = function ({ variant='primary', size='md' }) {
    return FeedbackIcon({variant, size, color: 'success', name: 'check-circle'});
};

export default { InfoFeedbackIcon, ErrorFeedbackIcon, WarningFeedbackIcon, SuccessFeedbackIcon };